/* eslint-disable @typescript-eslint/consistent-type-definitions -- Zero mutator/query arg types must be `type` aliases to satisfy the ReadonlyJSONValue constraint; interfaces lack an implicit index signature. */
import { defineMutator } from "@rocicorp/zero"

import type { ZeroJwtPayload } from "@productlane/lib/src/browser"

import type { MutatorTx } from "../schema"

export type SuggestionIdArgs = {
	id: string
}

async function loadOpenSuggestion(
	tx: MutatorTx,
	id: string,
	authData: ZeroJwtPayload,
) {
	const [row] = await tx.query.suggestions.where("id", "=", id).run()
	if (!row || row.workspaceId !== authData.workspaceId) return null
	if (row.dismissedAt != null) return null
	return row
}

export const suggestionMutators = {
	// Hides the suggestion on its thread for good; the job never offers that target there again.
	dismiss: defineMutator(
		async ({
			tx,
			args,
			ctx: authData,
		}: {
			tx: MutatorTx
			args: SuggestionIdArgs
			ctx: ZeroJwtPayload
		}) => {
			const row = await loadOpenSuggestion(tx, args.id, authData)
			if (!row) return
			await tx.mutate.suggestions.update({
				id: row.id,
				dismissedAt: Date.now(),
			})
		},
	),
	// The link itself goes through the issue or project link mutator; this only records the accept rate.
	accept: defineMutator(
		async ({
			tx,
			args,
			ctx: authData,
		}: {
			tx: MutatorTx
			args: SuggestionIdArgs
			ctx: ZeroJwtPayload
		}) => {
			const row = await loadOpenSuggestion(tx, args.id, authData)
			if (!row || row.acceptedAt != null) return
			await tx.mutate.suggestions.update({ id: row.id, acceptedAt: Date.now() })
		},
	),
}
